export default __webpack_public_path__ + "static/kg-88b153fedcfa259ee545acd9c7f0db29.png";